export default __webpack_public_path__ + "static/media/nicolas-capello-2.bacad037.webp";